import styled from "styled-components";

// components
import colors from "core/colors";
import Flexbox from "core/Flexbox";

// helpers
import { convertPxToRem } from "frontend/components/helpers";

export const HeadlineWithFort = styled(Flexbox).attrs({
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start"
})``;

export const IconBG = styled(Flexbox).attrs({
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
})`
    border-radius: 50%;
    width: ${convertPxToRem({ px: 28 })};
    height: ${convertPxToRem({ px: 28 })};
    background-color: ${colors.secondary.orca};
`;
